import { React, FC, useContext, useMemo} from 'external/react'
import {Button, styled} from 'external/material'
import { TeacherContext } from 'teacher/context'
import Resource from './Resource'
import confirmDialog from 'components/confirm-dialog'
import AddLinkResource from 'components/add-link-resource'

const StyledResources = styled('div')(resourcesStyles as any)

const Resources: FC = () => {

    const {newPlan, updateState, section, translate, navigate, match} = useContext(TeacherContext) as any

    const resourceItems: any[] = useMemo(() => newPlan.content?.resources || [],[newPlan.content])

    const updatePlan = (commands: any) => updateState({newPlan: commands})

    function deleteResource (index: number, resource:any) {
      confirmDialog({
        className: 'delete-field',
        translate: translate,
        children: (
          <div className="message">
            <div className="question">
              {translate('confirm_delete_item')}
            </div>
            <div className="title">
                {resource.title}
            </div>
          </div>
        ),
        onConfirm: () => {
          updatePlan({content: {resources: {$splice: [[index,1]]}}})
        }
      })
    }

    function addResourceClick() {
      navigate({section: 'add-link-resource'}, match.path, { preserveQuery: true })
    }

    return (
      <StyledResources className="planrd-resources">
        <div className='label'>
            {translate('resources')}
        </div>
        <Button onClick={addResourceClick} className='add-resource' >+</Button>
        {section == 'add-link-resource' ? <AddLinkResource /> : null}
        {resourceItems.length > 0 && (
          <div className="planrd-content">
            {resourceItems.map((resource, index) => ( <Resource key={index} onDeleteClick={() => deleteResource(index, resource)} title={resource.title} href={resource.href} />))}
          </div>
        )}
      </StyledResources>
    )
  }


function resourcesStyles() {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px', alignItems: 'center',
    borderBottom: '1px solid #d8d8d8',
    '& .label': {
      alignSelf: 'flex-start',
      color: '#868c9c' 
    },
    '& .add-resource': {
      backgroundColor: '#f0f7ff',
      border: '1px solid #a5b9de',
      color: '#a5b9de',
      width: '100%'
     },
     '& .planrd-content': {
        width: '100%',
     }
  }
}

export { Resources as default }